// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6jX3d","details":"styles_details__P-Ly0","reloadButton":"styles_reloadButton__Yxqpk"};